import { TicketDetailsPage } from './TicketDetails'
import { TicketsViewType } from './TicketsViewType'

const TicketSalesDetails = (): JSX.Element => {
  return <TicketDetailsPage viewType={TicketsViewType.Sales} />
}

export default TicketSalesDetails
